import React from "react";

const IconInstagramWhite = () => {
    return (
        <svg
            viewBox="0 0 512 512"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M391.659 138.966C381.398 138.966 373.035 130.624 373.035 120.342C373.035 110.059 381.376 101.718 391.659 101.718C401.942 101.718 410.283 110.059 410.283 120.342C410.283 130.624 401.92 138.966 391.659 138.966Z"
                fill="currentColor"
            />
            <path
                d="M101.333 512H410.667C466.539 512 512 466.539 512 410.667V101.333C512 45.4613 466.539 0 410.667 0H101.333C45.4613 0 0 45.4613 0 101.333V410.667C0 466.539 45.4613 512 101.333 512ZM32 101.333C32 63.104 63.104 32 101.333 32H410.667C448.896 32 480 63.104 480 101.333V410.667C480 448.896 448.896 480 410.667 480H101.333C63.104 480 32 448.896 32 410.667V101.333Z"
                fill="currentColor"
            />
            <path
                d="M256 386.773C328.107 386.773 386.773 328.107 386.773 256C386.773 183.893 328.107 125.227 256 125.227C183.893 125.227 125.227 183.893 125.227 256C125.227 328.107 183.893 386.773 256 386.773ZM256 157.227C310.464 157.227 354.773 201.536 354.773 256C354.773 310.464 310.464 354.773 256 354.773C201.536 354.773 157.227 310.464 157.227 256C157.227 201.536 201.536 157.227 256 157.227V157.227Z"
                fill="currentColor"
            />
            <path
                d="M391.637 157.056C412.672 157.056 428.523 141.27 428.523 120.342C428.523 98.5176 411.84 83.627 391.659 83.627C370.624 83.627 354.773 99.4136 354.773 120.342C354.773 142.123 371.371 157.056 391.637 157.056ZM395.413 116.822C402.155 122.774 386.773 130.006 386.773 120.363C386.773 114.603 394.603 116.096 395.413 116.822Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconInstagramWhite;
